// BrowseExploreJsonLd.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import serialize from 'serialize-javascript';

import { getCoporation } from '../resource/SchemaObject.js';
import { TranslationNamespace } from '../resource/translationNamespace.js';

export const BrowseExploreJsonLd = () => {
  const { t } = useTranslation();
  return (
    <Helmet>
      <script type="application/ld+json" helmetKey="jsonld">
        {serialize(
          {
            '@context': 'https://schema.org',
            '@graph': [
              getCoporation(),
              {
                '@type': 'WebSite',
                '@id': 'https://swag.live/#website',
                url: 'https://swag.live',
                name: t('seo-home-title', {
                  ns: TranslationNamespace.SEO,
                }),
                description: t('seo-home-description', {
                  ns: TranslationNamespace.SEO,
                }),
                image: {
                  '@id': 'https://swag.live/#logo',
                },
                mainEntity: {
                  '@id': 'https://swag.live/#webpage',
                },
                /* publisher prop will lead google not recogonize logo in Corporation
                publisher: {
                  '@id': 'https://swag.live/#corporation',
                },
                */
                potentialAction: {
                  '@type': 'SearchAction',
                  target: {
                    '@type': 'EntryPoint',
                    urlTemplate: 'https://swag.live/search/all?q={search_term}',
                  },
                  'query-input': 'required name=search_term',
                },
              },
              {
                '@type': 'WebPage',
                '@id': 'https://swag.live/explore#webpage',
                url: 'https://swag.live/explore',
                name: t('seo-explore-title', {
                  ns: TranslationNamespace.SEO,
                }),
                breadcrumb: {
                  '@id': 'https://swag.live/explore#breadcrumb',
                },
              },
              {
                '@type': 'BreadcrumbList',
                '@id': 'https://swag.live/explore#breadcrumb',
                itemListElement: [
                  {
                    '@type': 'ListItem',
                    position: 1,
                    name: t('seo-home-title', {
                      ns: TranslationNamespace.SEO,
                    }),
                    item: 'https://swag.live',
                  },
                  {
                    '@type': 'ListItem',
                    position: 2,
                    name: t('seo-explore-title', {
                      ns: TranslationNamespace.SEO,
                    }),
                    item: 'https://swag.live/explore',
                  },
                ],
              },
            ],
          },
          { isJSON: true }
        )}
      </script>
    </Helmet>
  );
};

BrowseExploreJsonLd.propTypes = {};

BrowseExploreJsonLd.defaultProps = {};

export default BrowseExploreJsonLd;
